var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v("Info")]),_c('VueFormGenerator',{attrs:{"schema":_vm.customObject.schema,"model":_vm.customObject.model,"options":_vm.customObject.formOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }